/* eslint-disable */
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import axios from "axios";
import FeaturesSlider from './FeaturesSlider';

export default {
  initForm() {
    const asyncForm = document.querySelectorAll("[data-async]");

    for (let i = 0; i < asyncForm.length; i++) {
      asyncForm[i].addEventListener("submit", function (e) {
        e.preventDefault();
        const $form = this;
        const formData = new FormData($form);
        const options = {
          method: $form.dataset.method,
          headers: { "content-type": "application/x-www-form-urlencoded" },
          data: formData,
          url: $form.dataset.action,
        };
        const recaptchaInput = $form.querySelector('.hiddenRecaptcha');
        let valid = false;

        if(recaptchaInput) {
          const recaptchaValue = recaptchaInput.value;
          if(recaptchaValue != "") {
            valid = true;
          } else {
            valid = false;
          }
        } else {
          valid = true;
        }        
        
        if(valid) {
          $form.classList.add("is-loading");
          axios(options)
            .then((response) => {
              console.log("Success response:", response.data);
              if (response.data.status === "load-posts") {
                setTimeout(function () {
                  $form.classList.remove("is-loading");
                  showProducts($form, response.data);
                }, 1000);
              } else if (response.data.status === "badfields") {
                setTimeout(function () {
                  $form.classList.remove("is-loading");
                  badFields($form, response.data);
                }, 500);
              } else if (response.data.status === "success") {
                if ($form.classList.contains("cookie__form")) {
                  $form.closest(".cookie").classList.remove("is-shown");
                } else {
                  setTimeout(function () {
                    $form.classList.remove("is-loading");
                    showMessage($form, response.data);
                    gaEvent($form);
                  }, 1000);
                }
              } else if (response.data.status === "error") {
                setTimeout(function () {
                  $form.classList.remove("is-loading");
                  showMessage($form, response.data);
                }, 1000);
              }
            })
            .catch((error) => {
              console.log("Error response:", error);
            });
        }
      });
    }

    const badFields = (f, resp) => {
      resp.fields.map((field, i) => {
        const targetField = f.querySelector(`[name="${field.name}"]`);
        const targetContainer = targetField.closest(".form-input");
        targetContainer.querySelector(".form-input__field-message").innerHTML =
          field.errorMessage;
        targetContainer.classList.add("form-input--has-error");
      });
    };

    const showMessage = (f, resp) => {
      const modal = document.getElementById('response-modal');
      const close = modal.querySelector('.js-close-modal');
      const title = document.getElementById('response-title');
      const subtitle = document.getElementById('response-subtitle');
      close.addEventListener('click', () => {
        modal.classList.remove('modal--show');
      })
      title.innerHTML = resp.output.title;
      subtitle.innerHTML = resp.output.subtitle;
      if (resp.status === "success") {
        modal.classList.remove('modal--error');
        modal.classList.add('modal--show');
        modal.classList.remove( 'trial', 'contact' );
        modal.classList.add( resp.output.type );
        setTimeout(function () {
          resetForm(f);
        }, 2000);
      }
      if (resp.status === "error") {
        modal.classList.add('modal--error');
        modal.classList.add('modal--show');
      }
    };

    const gaEvent = (f) => {
      let formtype = f.dataset.formtype;
      if (typeof formtype !== 'undefined' && typeof gtag !== 'undefined') {
        gtag('event', 'screen_view', { 'app_name': 'form','screen_name': formtype });
        console.log(formtype);
      }
    };

    const showProducts = (f, resp) => {
      const container = document.getElementById('features-holder');
      const pagaValue = f.querySelector('[name="page"]');

      pagaValue.value = +pagaValue.value + 1;

      resp.data.forEach(post => {
        container.insertAdjacentHTML('beforeend', post);
      })

      if(resp.current_page === resp.total_pages) {
        f.remove();
      }

      const newBlocks = container.querySelectorAll('.features__slider');
      newBlocks.forEach(block => {
        if(!block.classList.contains('swiper-container-initialized')) {
          FeaturesSlider.init(block);
        }
      })

    }

    const resetForm = (f) => {
      const inputs = f.querySelectorAll(".form-input");
      const textareas = f.querySelectorAll("textarea");
      const containers = document.querySelectorAll(".js-select-container");
      const reInputs = f.querySelectorAll(".hiddenRecaptcha");

      if (reInputs.length > 0) {
        reInputs.forEach((input) => {
          input.value = "";
        });
      }

      if (containers.length > 0) {
        containers.forEach((container) => {
          const selectors = container.querySelectorAll(".js-select");

          selectors.forEach((selector) => {
            selector.classList.remove("is-selected");
          });
        });
      }

      f.reset();
      for (let i = 0; i < textareas.length; i++) {
        textareas[i].style.height = 50 + "px";
      }
      for (let i = 0; i < inputs.length; i++) {
        inputs[i].classList.remove("full");
        inputs[i].classList.remove("form-input--has-error");
      }
    };
  },
  /*
   * Renders the two reCAPTCHA widgets without ever being able to throw.
   *
   * header.php loads Google's api.js with `async defer` and `render=explicit`,
   * so `grecaptcha` is simply absent whenever that request fails -- an
   * ad-blocker or privacy extension, a CSP, a region where Google is not
   * reachable, or a flaky network. The old version called `grecaptcha.render`
   * unguarded, so that raised a ReferenceError inside `inits()`, which is a
   * flat sequence: every component registered after this one (sliders, cookie
   * banner, FAQ, tabs, calculator, back-to-top, header scroll) never
   * initialised. One blocked third-party request took down the page's JS.
   *
   * It also no longer assumes the API has arrived by the time this runs: it
   * waits for it, bounded, and gives up quietly instead of hanging on a script
   * that is never coming.
   */
  initRecaptcha() {
    const targets = [
      { id: 'g-recaptcha-2', hidden: 'tf_hiddenRecaptcha' },
      { id: 'g-recaptcha', hidden: 'cf_hiddenRecaptcha' }
    ].filter(t => document.getElementById(t.id));

    if (!targets.length) return;

    const setHidden = (id, value) => {
      const field = document.getElementById(id);
      if (field) field.value = value;
    };

    const render = () => {
      targets.forEach(t => {
        const el = document.getElementById(t.id);
        // grecaptcha.render() throws if the container already holds a widget,
        // so mark each one as it goes.
        if (!el || el.dataset.rendered) return;

        try {
          window.grecaptcha.render(t.id, {
            sitekey: el.dataset.sitekey,
            callback: response => setHidden(t.hidden, response),
            'expired-callback': () => setHidden(t.hidden, '')
          });
          el.dataset.rendered = '1';
        } catch (e) {
          // Leave it unrendered rather than take the init chain down with it.
        }
      });
    };

    let tries = 0;
    const whenReady = () => {
      if (window.grecaptcha && window.grecaptcha.render) {
        render();
        return;
      }
      // ~10s in 250ms steps, then stop: the script is not coming.
      if (++tries > 40) return;
      window.setTimeout(whenReady, 250);
    };

    whenReady();
  }
};
